/**
 * User-facing labels for transaction direction.
 * Maps Purchase/Redemption (and BUY/SELL) → Buy/Sell.
 * Leaves Realized / Unrealized (and other types) unchanged.
 */
export const formatBuySellTxnTypeLabel = (type?: string | null): string => {
  const raw = String(type ?? "").trim();
  if (!raw) return "-";

  const lower = raw.toLowerCase();
  if (lower === "unrealized" || lower === "unrealised") return raw;
  if (lower === "realized" || lower === "realised") return raw;

  const key = raw.replace(/\s+/g, "_").toUpperCase();
  if (key === "BUY" || key === "PURCHASE") return "Buy";
  if (key === "SELL" || key === "REDEMPTION" || key === "REDEEM") return "Sell";
  if (lower === "purchase") return "Buy";
  if (lower === "redemption" || lower === "redeem") return "Sell";

  return raw;
};
